export default __webpack_public_path__ + "side-square.svg";